export const WorkoutPlayerControls = {
  bindings: {
    playing: '<',
    completed: '<',
    continuous: '<',
    previousStep: '<',
    nextStep: '<',
    onToggle: '&',
    onToggleContinuous: '&',
    onRestart: '&',
    onBack: '&',
    onNext: '&',
    onFinish: '&',
  },

  template: `
    <div class="d-flex">
      <div class="text-center switch-content">
        <label class="switch">
          <input
            type="checkbox"
            ng-model="$ctrl.continuous"
            ng-change="$ctrl.onToggleContinuous()">
          <i></i>
        </label>
        <p>AutoPlay</p>
      </div>
      <div class="workout-player-controls-inner d-flex">
        <button class="back-btn"
          type="button"
          ng-class="{ 'disabled': !$ctrl.previousStep }"
          ng-click="$ctrl.previousStep && $ctrl.onBack()">
          Back
        </button>
        <button class="play-btn"
          type="button"
          ng-click="$ctrl.onToggle()"
          ng-hide="$ctrl.completed">
          <i class="fa"
            ng-class="$ctrl.playing ? 'fa-pause' : 'fa-play'">
          </i>
        </button>
        <button class="play-btn"
          type="button"
          ng-click="$ctrl.onRestart()"
          ng-show="$ctrl.completed">
          <i class="fa fa-rotate-left"></i>
        </button>
        <button class="next-btn"
          type="button"
          ng-click="$ctrl.onNext()">
          {{ $ctrl.nextStep && 'Next' || 'Finish' }}
        </button>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/WorkoutPlayer/WorkoutPlayerControls.js